import { useEffect, useRef, useState, useCallback } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const NARRATOR = "echo";
export const getVoice = () => NARRATOR;

const cache = new Map();
export async function getAudioUrl(text, voice = NARRATOR) {
  const k = `${voice}|${text}`;
  if (!cache.has(k)) {
    cache.set(k, api.post("/tts", { text, voice }, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data)).catch((e) => { cache.delete(k); throw e; }));
  }
  return cache.get(k);
}

export function useNarrator() {
  const [speaking, setSpeaking] = useState(null);
  const [loading, setLoading] = useState(null);
  const audio = useRef(null);
  const seq = useRef(0);
  const alive = useRef(true);
  const cur = useRef({ speaking: null, loading: null });
  cur.current = { speaking, loading };

  const stop = useCallback(() => {
    seq.current++;
    if (audio.current) { audio.current.pause(); audio.current.onended = null; if (active === audio.current) active = null; audio.current = null; }
    if (alive.current) { setSpeaking(null); setLoading(null); }
  }, []);

  const speak = useCallback(async (id, text, opts = {}) => {
    if (cur.current.speaking === id || cur.current.loading === id) { stop(); return false; }
    stop();
    stopAllNarration();
    const my = seq.current;
    setLoading(id);
    try {
      const url = await getAudioUrl(text, opts.voice);
      if (my !== seq.current || !alive.current) return false;
      const a = new Audio(url);
      audio.current = a; active = a;
      a.onended = () => { if (audio.current === a) { audio.current = null; if (active === a) active = null; setSpeaking(null); opts.onEnd?.(); } };
      await a.play();
      if (my !== seq.current || !alive.current) { a.pause(); return false; }
      setLoading(null); setSpeaking(id);
      return true;
    } catch (e) {
      if (my !== seq.current || !alive.current) return false;
      setLoading(null); setSpeaking(null);
      if (e?.name !== "NotAllowedError") toast.error("Narration is unavailable right now");
      return false;
    }
  }, [stop]);

  useEffect(() => { alive.current = true; return () => { alive.current = false; stop(); }; }, [stop]);
  return { speaking, loading, speak, stop };
}

let active = null;
export function stopAllNarration() {
  if (active) { active.pause(); active.onended = null; active = null; }
}
